import { Routes } from '@angular/router';

import { LayoutModulosComponent } from '../core/layout/layout-modulos/layout-modulos.component';
import { ModulosHomeComponent } from '../features/modulos/modulos-home/modulos-home.component';
import { AutenticacaoGuard } from '../core/guards/autenticacao.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'acesso/login',
  },

  {
    path: 'acesso',
    loadChildren: () =>
      import('../features/acesso/acesso.routes').then((m) => m.ACESSO_ROUTES),
    data: { preload: false },
  },

  {
    path: 'solicitar-recuperacao-senha',
    pathMatch: 'full',
    redirectTo: 'acesso/recuperar-senha',
  },

  {
    path: 'nova-senha',
    pathMatch: 'full',
    redirectTo: 'acesso/nova-senha',
  },

  {
    path: '',
    component: LayoutModulosComponent,
    canActivate: [AutenticacaoGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'modulos',
      },

      {
        path: 'modulos',
        component: ModulosHomeComponent,
      },

      {
        path: 'empresas',
        loadChildren: () =>
          import('../features/empresas/empresas.routes').then(
            (m) => m.EMPRESAS_ROUTES,
          ),
        data: {
          preload: true,
          delay: 2000,
        },
      },

      {
        path: 'relatorios',
        loadChildren: () =>
          import('../features/relatorios/relatorios.routes').then(
            (m) => m.RELATORIOS_ROUTES,
          ),
        data: {
          preload: true,
          delay: 3000,
        },
      },

      {
        path: 'med',
        loadChildren: () =>
          import('../features/transacoes/transacoes.routes').then(
            (m) => m.TRANSACOES_ROUTES,
          ),
        data: {
          preload: true,
          delay: 4000,
        },
      },
    ],
  },

  {
    path: '**',
    loadChildren: () =>
      import('../features/error/error.routes').then((m) => m.ERROR_ROUTES),
    data: { preload: false },
  },
];
